export const SHOP_CATEGORIES = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Earrings',
    value: 'earrings',
  },
  {
    label: 'Pendants',
    value: 'pendants',
  },
  {
    label: 'Rings',
    value: 'rings',
  },
  {
    label: 'Nose',
    value: 'nose',
  },
  {
    label: 'Sets',
    value: 'sets',
  },
];
